// import { Ref, ref, watch } from 'vue';

// const filterObject = (obj: any, callback: any) => Object.fromEntries(Object.entries(obj).filter(([key, val]) => callback(val, key)));

const getClassName = (...args: any): string => {
  const classes: any[] = [];

  for (let i = 0; i < args.length; i++) {
    const arg = args[i];

    if (!arg) {
      continue;
    }

    const argType = typeof arg;

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg) && arg.length) {
      const inner = getClassName(arg);
      if (inner) {
        classes.push(inner);
      }
    } else if (argType === 'object') {
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
        classes.push(arg.toString());
        continue;
      }

      for (const key in arg) {
        if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
};

// const getClassByRef = (inputProp: Ref<Any>, params, defaultValue = null) => {
//   const classes: Ref<string> = ref();
//   const defaultClasses = Object.values(filterObject(params, (key, val) => val === defaultValue)).pop();

//   const calc = (propVal: any, params: any) => {
//     console.log('propval', propVal);
//     if (!propVal) {
//       return;
//     }

//     const classesArray = [];

//     for (const key in params) {
//       if (Object.prototype.hasOwnProperty.call(arg, key) && arg[key]) {
//         classesArray.push(key);
//       }
//     }

//     if (classes.value.length === 0 && defaultClasses) {
//       classesArray.value.push(defaultClasses);
//     }

//     classes.value = classesArray.join(' ');
//   };

//   watch(inputProp, val => calc(val, params));

//   if (inputProp) {
//     calc(inputProp.value, params);
//   } else if (defaultClasses) {
//     classes.value = defaultClasses;
//   }

//   return classes;
// };

export const useClassName = () => ({ getClassName });
